import { lazy } from 'react';

export const LingobotDashboardPage = lazy(() => import('./LingobotDashboardPage'));
